import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {GlobalServices} from './global.services';
import {ApiService} from './api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SubscriptionPlanService } from './services/subscription-plan.service';
import { baseUrls } from './appConstant';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'homewellness';
  userDetails: any;

  constructor(public globalService: GlobalServices, public httpService: ApiService,
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private subscriptionPlanService: SubscriptionPlanService,
    private changeDetection: ChangeDetectorRef){
    if (this.globalService?.isLoggedIn) {
      this.globalchecklogintoken();
    }
  }
  mode = "indeterminate";
  baseUrls= baseUrls;
  showFooter = true;
  showHeader = true;
  subscriptionForHeader = new Subscription;
  subscriptionForFooter = new Subscription;
  ngOnInit() {
    // console.log('global');
    if (this.globalService?.isBrowser) {
       //to check header and footer visbility
       this.subscriptionForHeader =  this.globalService.hideHeader?.subscribe((response) => {
        // console.log("ngAfterViewInit_Home", response);
        if(response){
          // setTimeout(() => {
            this.showHeader = false;
            this.changeDetection?.detectChanges();
            // console.log("ngAfterViewInit_Home_if", this.showHeader);
          // }, 0);
        }
        else{
          // setTimeout(() => {
            this.showHeader = true;
            this.changeDetection?.detectChanges();
            // console.log("ngAfterViewInit_Home_else", this.showHeader);
          // }, 0);
        }
      });
      this.subscriptionForFooter =  this.globalService.hideFooter.subscribe((response) => {
        if(response){
          this.showFooter = false;
          this.changeDetection?.detectChanges();
        }
        else{
          this.showFooter = true;
          this.changeDetection?.detectChanges();
        }
      });
      // TO CHECK COOKIES ARE ENABLED IN BROWSER or NOT
      // this.checkCookie();
      if (localStorage.getItem('cartquantity') === null) {
        localStorage.setItem('cartquantity', '-1');
      }
      // console.log('ngOnInit', this.router.url, this.location);
      const path = this.location.path();
      // console.log('ngOnInit2', path);

      if(path.includes('inviteToken')){
        localStorage.setItem('inviteToken', path.split('inviteToken=')[1])
        // this.router.navigate(['home']); // pop up open of sign up 
      }
      else{
        // this.router.navigate(['home'])
      }
      // console.log('ngOnInit', this.router.url );
      this.activatedRoute?.queryParams.subscribe((urlResponse: any) => {
        if(urlResponse){
          // console.log('urlResponse', urlResponse, urlResponse['member-email'], 
          // urlResponse?.sig , urlResponse['virtuagym-member-id']);
          this.loginWithUrl(urlResponse?.['member-email'], urlResponse?.sig , urlResponse['virtuagym-member-id']);
        }
      });
      setTimeout(() => {
        this.mode  = 'determinant';
      },2000)
      
    }
  }

  // ngAfterViewInit(){
  //   if (this.globalService?.isBrowser) {
     
  //   }
  // }
  globalchecklogintoken(): any {
    // console.log('123');
    if (this.globalService.isLoggedIn) {
      let url = "user/logincheck";
      let data = {
        "userId": localStorage.getItem('userToken')
      };
      this.httpService.postFormData(url, data).subscribe(response => {
        if (!response.login) {
          // this.globalService.frommyaccountforhome = true;
          this.logOut();
          window.location.href = '/';
        }
      });
    }
    // return false;
  }

  public logOut() {
    if (this.globalService.isBrowser) {
      this.userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : null;
    }
    let urlForgotPassword = "user/logout";
    // this.mode = 'indeterminate';
    let data = { userId: this.userDetails ? this.userDetails['_id'] : null };
    this.httpService.postFormData(urlForgotPassword, data).subscribe(response => {
      if (response.success) {
        this.globalService.isLoggedIn = false;
        if (this.globalService.isBrowser) {
          let quantity = Number(localStorage.getItem('cartquantity'));
          // console.log(quantity);
          while (quantity > -1) {
            localStorage.removeItem('cartdata_' + quantity);
            quantity = quantity - 1;
          }
          //   for(let i = quantity; i >= 0; i++){
          //     localStorage.removeItem('cartdata_' + i);
          //   }

          this.globalService.cartquantity = 0;
          localStorage.removeItem('cartquantity');
          localStorage.removeItem('userDetails');
          localStorage.removeItem('userToken');
          localStorage.removeItem("userEmail");
          localStorage.removeItem("userPass");
          localStorage.removeItem('planpayment');
          localStorage.removeItem('dataArray');
          window.location.href = '/';
        }
        // this.router.navigate(['/']);
      }
      if (this.globalService.isBrowser) {
        localStorage.removeItem('cartquantity');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('userToken');
        localStorage.removeItem("userEmail");
        localStorage.removeItem('planpayment');
        localStorage.removeItem('dataArray');
        localStorage.removeItem("userPass");
      }
      // this.mode = 'indeterminate';
    });
  }

  loginWithUrl(emailPassed, sigPassed, memberIdPassed){
    // console.log('loginWithUrl', emailPassed, sigPassed, memberIdPassed);
    if(emailPassed && sigPassed  && memberIdPassed){
      let obj = {
        email: emailPassed,
        type:"virtuagym",
        password:"",
        sig: sigPassed,
        memberId: memberIdPassed
      }
      let url = "user/login";
      localStorage.setItem("userEmail", obj.email);
      localStorage.setItem("userPass", "");
      
      this.mode = 'indeterminate';
      this.httpService.postFormData(url, obj).subscribe(response => {
        if (response.success) {
          this.globalService.isLoggedIn = true;
          
          response['data']['siteUrl'] = response['siteUrl'];

          localStorage.setItem('userDetails', JSON.stringify(response['data']));
          localStorage.setItem('userToken', response['token']);
          this.globalService.userDetails = JSON.parse(JSON.stringify(response['data']));
          this.getUserCurrentPlan();
          if(response['isSubscriptionPurchased']){
            localStorage.setItem('isSubscriptionPurchased', JSON.stringify(response['isSubscriptionPurchased']));
          }
          if(response?.data?.timezone){
            localStorage.setItem('timezone', JSON.stringify(response['data']["timezone"]));
          }
          if (JSON.parse(localStorage.getItem('cartdata')) !== null) {
            let datum = [];
            var a = [];
            a = JSON.parse(localStorage.getItem('cartdata'));
            a.forEach(el => {
              let date = el.date?.split('-');
              let dat = {
                type: el.portal,
                productId: el.programId,
                productInfo: {
                  bookingStartDate: date && date[0] ? date[0] : new Date(),
                  bookingEndDate: date && date[1] ? date[1] : new Date(),
                  accommodationId: el.accommodationId,
                  noOfPeople: el.people,
                  addonsId: el.totalAddonsId,
                },
                pay: el.payStatus
              };
              datum.push(dat);
            });
            const headerDict = {
              token: localStorage.getItem('userToken')
            };
            let newdatum = {data: datum};

            let Url = "billingservice/cartservice/create";
            this.httpService.postFormDataBilling(Url, newdatum, headerDict).subscribe(response1 => {
              // console.log(response1);
              localStorage.removeItem('cartdata');
              localStorage.setItem('cartquantity', String(response1.count - 1));
              this.globalService.cartquantity = Number(response1.count);
    // this.globalService.signupPage = {show:true,id:this._id,type:this.type};
    // console.log(this.globalService.signupPage['show']);
              if(this.globalService.priceCheck){
                this.router.navigate([this.globalService.priceCheck['free']]);
                // window.location.href = '/'+this.globalService.priceCheck['free'];
                // console.log(this.globalService.signupPage['show']);
              }else if(this.globalService.signupPage['show']){
              this.globalService.signupTriggerForSignupPage.next(true);
                this.router.navigate(['subscribe',this.globalService.signupPage['id']+'-'+this.globalService.signupPage['type']]);
              }else{
                this.globalService.signupStatus=true;
                // this.router.navigate(['home']);
                // setTimeout(() => {
                //   this.globalService.subjectTriggerForPlanPage.next(true);
                // },0)
                // window.location.href = '/plan';
              }
            });
          }
          else {
            localStorage.setItem('cartquantity', String(response.count - 1));
            this.globalService.cartquantity = Number(response.count);
            if(this.globalService.priceCheck){
              this.router.navigate([this.globalService.priceCheck['free']]);
              // window.location.href = '/'+this.globalService.priceCheck['free'];
            }else if(this.globalService.signupPage['show']){
              this.globalService.signupTriggerForSignupPage.next(true);
              this.router.navigate(['subscribe',this.globalService.signupPage['id']+'-'+this.globalService.signupPage['type']]);
            }else{
              this.globalService.signupStatus=true;
              // this.router.navigate(['home']);
              // setTimeout(() => {
              //   this.globalService.subjectTriggerForPlanPage.next(true);
              // },0)
              // window.location.href = '/plan';
            }
          }
          let userDetails = JSON.parse(localStorage.getItem("userDetails"));
          this.globalService.firstname = userDetails ? userDetails.firstName: '';
          this.globalService.imgSrc = userDetails && userDetails['images'] && userDetails['images']['path'] ? baseUrls['images'] + userDetails['images']['path'] + userDetails['images']['name'] : 'assets/images/profile-picture.png';
          this.globalService?.subjectTriggerForLoginDetectAtHeader?.next(true);
          this.globalService?.viewcontainerhelper?.clear();
        } else {
          // console.log(response);
          // this.wrongPassword = response['message'];
          // if (response['statusCode'] == '03') {
          //   this.errorMsg = response['message'];
          // } else {
          //   this.wrongPassword = response['message'];
          // }
          // this.cd.detectChanges();
        }
        this.mode = 'determinate';
      });
    }
  }
  userCurrentPlans = [];
getUserCurrentPlan(){
  if(this.globalService?.isLoggedIn){
    const userId = JSON.parse(localStorage.getItem('userDetails'))?._id;
    this.httpService.getDatabill(`billingservice/usersubscription/subs/${userId}`).subscribe((subscribePlan: any) => {
      if(subscribePlan){
        // console.log('getUserCurrentPlan', subscribePlan);
        this.userCurrentPlans = subscribePlan;
        localStorage.setItem('userSubscriptionPlan', JSON.stringify(subscribePlan))
        this.getSubscriptionPlan();
      }
    })
  }
}
getSubscriptionPlan(){
  this.subscriptionPlanService.getSubscriptionDetail().subscribe((response:any) => {
    // console.log('getSubscriptionPlan', response);
    if(response?.data?._id){
      this.userCurrentPlans?.forEach((obj: any) => {
        if(obj?.subscriptionId == response?.data?._id){
           console.log('getSubscriptionPlan', obj?.subscriptionId == response?.data?._id, obj?._id, response?.data?._id);
          this.globalService.moveToPlanPage.next(false);
          localStorage.setItem('moveToPlanPage', 'false');
          return;
        }
      })
    }
  });
}
checkCookie(){
  if(this.globalService?.isBrowser){
    // let cookieEnabled = navigator.cookieEnabled;
    // if (!cookieEnabled){ 
    //     document.cookie = "testcookie";
    //     cookieEnabled = document.cookie.indexOf("testcookie")!=-1;
    // }
    // return cookieEnabled || this.showCookieFail();

    if(navigator.cookieEnabled){

    }
    else{
      this.showCookieFail();
    }
  }
}
showCookieFail(){
// do something here
alert('Please allow cookies from browser for better experience !!');
}

ngOnDestroy(){
  this.subscriptionForHeader?.unsubscribe();
  this.subscriptionForFooter?.unsubscribe();
}
}

